import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3m4.58 6.48-5 6c-.13.16-.33.26-.54.27-.21 0-.42-.07-.56-.22l-3-3a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.42 2.42 4.47-5.37c.27-.32.74-.36 1.06-.1.32.27.36.74.1 1.06z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckSolid;
